
import * as AuthActions from '../Actions/AuthActions'

function getStorageData(){
    if(localStorage.getItem('okta-token-storage')){        
        const data = JSON.parse(localStorage.getItem('okta-token-storage'));
        let roleBase = data?.accessToken?.claims?.pepappconsumerroles?.map( item => item)
    
        // const auth = {
        //     accessToken:data?.accessToken,
        //     idToken:data?.idToken
        // }
        const authInitState = {
            // authState : auth,
            isAuthenticated : data?.accessToken ? true : false,
           // roles : ['admin']
            //  roles : ['partneriam-0oa4lotzuw5ZCrL0e5d7','partneriam-0oa2x0pragJoZ5WQb5d7','partneriam-admin']
            roles : roleBase
        }
        // console.log({authInitState})
        return authInitState   
    }else{
        const loginInitialState = {
            authState:null,
            isAuthenticated:false,
            roles: ['']
        }
        return loginInitialState;
    }
    
}

export const loginInitialState = getStorageData();

const authUserReducer  = (state=loginInitialState,action)=>{
    switch(action.type){
        case  AuthActions.USER_LOGIN:
            return {
                ...state,
                // authState:action.payload.authState,
                isAuthenticated:action.payload.isAuthenticated,
                roles:action.payload.roles
            }
        case AuthActions.USER_LOGOUT:
            return{
                ...state,
                // authState: {},
                isAuthenticated: false,
                roles:[]
            }
        default:
            return state
    }
}

export default authUserReducer;